<div class="otp-code-flow">
  <form (ngSubmit)="submitForm()" [formGroup]="validationForm">
    <div class="padding-mobile-left-right mb-3">
      <div class="col-12">
        <div *ngIf="!isSPOEEnabled" class="subheading_instruction">
          <adp-label labelKey="Signup_Create_Account_Contact_Subheading_Text"></adp-label>
        </div>
        <div *ngIf="isSPOEEnabled" class="spoe_subheading_instruction">
          <adp-label labelKey="SPOE_LookupUser_ReviewAddress_Verify_ConfirmInstruction"></adp-label>
        </div>
      </div>
    </div>
    <div class="validate-form">

      <adp-input class="w-100" *ngIf="showPhoneNumber"
        [resourceData]="resourceService.getResourceObject('Signup_Create_Account_MobileNumber_Field')"
        formControlName="Phone">
      </adp-input>

      <mat-checkbox color="accent" formControlName="Consent" *ngIf="showPhoneConsent">
        <adp-label class="contact-checkbox" labelKey="Signup_Create_Account_SMSConsent_Text"></adp-label>
      </mat-checkbox>

      <p class="fw-600 mt-30 mb-25" *ngIf="!isSPOEEnabled">
        <adp-label labelKey="LookupUser_ReviewAddress_Verify_TitleText"></adp-label>
      </p>

      <div class="spoe_address_subheading_instruction" style="margin-bottom:20px;" *ngIf="isSPOEEnabled">
        <adp-label labelKey="SPOE_LookupUser_ReviewAddress_Verify_Title"></adp-label>
      </div>

      <div *ngIf="isGoogleMapsApiLoaded">
        <mat-form-field class="w-100">
          <mat-label>{{addressResourceInfo.PlaceHolder}}</mat-label>
          <input (change)="sanitizeInput($event)"
            pghMatGoogleMapsAutocompleteCustom [country]="'us'"
            (onAutocompleteSelected)="onAddressMapped($event)"
            formControlName="Address1"
            maxlength="{{ addressResourceInfo.MaxValue }}" minlength="{{ addressResourceInfo.MinValue }}"
            required="{{ addressResourceInfo.IsRequired }}" pattern="{{ addressResourceInfo.ValidationRegex }}" matInput
            [options]="googlePlacesOptions"
            [mask]="addressResourceInfo.MaskRegex" autocomplete="off" />

          <mat-error *ngIf="validationForm.get('Address1').hasError('required')" style="margin-top:15px;">
            {{
            resourceService.getViewLabel('Global_Text_VMRequired')
            ? resourceService.getViewLabel('Global_Text_VMRequired')
            : addressResourceInfo.ValidationMessage
            }}
          </mat-error>
          <mat-error *ngIf="validationForm.get('Address1').hasError('pattern')" style="margin-top:15px;">
            {{
            addressResourceInfo.ValidationMessage
            ? addressResourceInfo.ValidationMessage
            : resourceService.getViewLabel('Global_Text_VMPattern')
            }}
          </mat-error>
          <mat-error *ngIf="validationForm.get('Address1').hasError('minlength')" style="margin-top:15px;">
            {{
            addressResourceInfo.ValidationMessage
            ? addressResourceInfo.ValidationMessage
            : resourceService.getViewLabel('Global_Text_VMMinLength')
            }}
          </mat-error>
          <mat-error *ngIf="validationForm.get('Address1').hasError('maxlength')" style="margin-top:15px;">
            {{
            addressResourceInfo.ValidationMessage
            ? addressResourceInfo.ValidationMessage
            : resourceService.getViewLabel('Global_Text_VMMaxLength')
            }}
          </mat-error>
        </mat-form-field>

        <!--<adp-input [resourceData]="resourceService.getResourceObject('Signup_Create_Account_Address2_Field')"
          formControlName="Address2" [autocomplete]="'address-line2'" class="w-100"></adp-input>-->

        <div class="w-100" *ngIf="!resourceService.getResourceObject('Signup_Create_Account_Address2_Field').Hidden">
          <adp-input [resourceData]="resourceService.getResourceObject('Signup_Create_Account_Address2_Field')"
          formControlName="Address2" [autocomplete]="'address-line2'" class="w-100"></adp-input>
        </div>
        <!-- <div class="form-group">
        <adp-input [resourceData]="getResourceObject('Address3', 'Field')" formControlName="Address3"
          class="fullWidth" [autocomplete]="'address-line3'"></adp-input>
      </div> -->

        <div class="w-100" *ngIf="!resourceService.getResourceObject('Signup_Create_Account_City_Field').Hidden">
          <adp-input [resourceData]="resourceService.getResourceObject('Signup_Create_Account_City_Field')"
            formControlName="City" class="fullWidth" [autocomplete]="'address-level2'" class="w-100"></adp-input>
        </div>
        <div class="w-100" *ngIf="!resourceService.getResourceObject('Signup_Create_Account_State_Field').Hidden">
          <div class="form-group">
            <adp-select [resourceData]="resourceService.getResourceObject('Signup_Create_Account_State_Field')"
              [listItems]="states" formControlName="State" class="fullWidth" [autocomplete]="'address-level1'"
              class="w-100"></adp-select>
          </div>
        </div>
        <div class="w-100">
          <div class="form-group">
            <adp-input [resourceData]="resourceService.getResourceObject('Signup_Create_Account_Zip_Field')"
              formControlName="ZipCode" class="w-100" upper-case></adp-input>
          </div>
        </div>

        <mat-error *ngIf="validationError" class="otp-error">{{validationError}}</mat-error>

        <div class="form-group mb-4" [ngClass]="{'mt-4': validationError}">
          <button mat-flat-button class="next-btn" color="accent" type="submit"
            [disabled]="!validationForm.valid || validationError">
            <adp-label labelKey="Signup_Create_Account_Contact_SubmitButton_Text"></adp-label>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
